import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 25
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function TestimonialsSection() {
  return <section className="w-full bg-brand-card py-20 md:py-28 px-6" data-id="element-475">
      <div className="max-w-5xl mx-auto" data-id="element-476">
        <motion.div className="relative text-center mb-14" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-477">
          <div className="absolute left-1/2 -translate-x-1/2 top-[-20%] w-[800px] h-[600px] bg-[#000000]/[0.05] rounded-full blur-[120px] pointer-events-none" data-id="element-478" />
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-gray-900 leading-tight relative z-10" data-id="element-479">
            Resultados reales de
            <br data-id="element-480" />
            <span className="text-[#000000]" data-id="element-481">personas como vos</span>
          </h2>
          <p className="text-lg md:text-2xl text-gray-600 mt-4 relative z-10" data-id="element-482">
            Esto dicen quienes ya están aplicando el curso 👇
          </p>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} data-id="element-483">
          <motion.div variants={itemVariants} className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-484">
            <p className="text-brand-dark/70 leading-relaxed mb-6" data-id="element-485">
              "Por fin alguien que te explica las cosas de forma simple. Dejé de
              dar vueltas y empecé a{' '}
              <span className="text-brand-green font-semibold" data-id="element-486">avanzar</span> de
              verdad."
            </p>
            <div className="flex items-center gap-3" data-id="element-487">
              <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center text-brand-green font-semibold text-sm" aria-hidden="true" data-id="element-488">
                M
              </div>
              <span className="text-sm font-medium text-brand-dark" data-id="element-489">
                Martina
              </span>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-490">
            <p className="text-brand-dark/70 leading-relaxed mb-6" data-id="element-491">
              "Había probado de todo y nada me funcionaba. Este curso me dio la{' '}
              <span className="text-brand-green font-semibold" data-id="element-492">claridad</span>{' '}
              que necesitaba para elegir un camino y seguirlo."
            </p>
            <div className="flex items-center gap-3" data-id="element-493">
              <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center text-brand-green font-semibold text-sm" aria-hidden="true" data-id="element-494">
                L
              </div>
              <span className="text-sm font-medium text-brand-dark" data-id="element-495">Lucas</span>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-496">
            <p className="text-brand-dark/70 leading-relaxed mb-6" data-id="element-497">
              &quot;Lo mejor es que va directo al punto. Sin relleno, sin
              promesas exageradas. Justo{' '}
              <span className="text-brand-green font-semibold" data-id="element-498">
                lo que necesitaba
              </span>{' '}
              para empezar."
            </p>
            <div className="flex items-center gap-3" data-id="element-499">
              <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center text-brand-green font-semibold text-sm" aria-hidden="true" data-id="element-500">
                S
              </div>
              <span className="text-sm font-medium text-brand-dark" data-id="element-501">Sofía</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}